// Dynamic BPO campaign portal — FILE-BASED (no database yet).
//
// The dashboard reads its numbers from ONE spreadsheet you update periodically.
// Two ways to refresh:
//   1) Replace the file at DATA_URL (in /public) in the repo and redeploy —
//      that's the shared data everyone sees.
//   2) Use the "Cargar archivo" button in the portal to preview a file instantly
//      in your own browser (not shared; clears on refresh).
// Add Supabase later if you ever need real logins + per-client isolation.

// Where the shared data file lives, inside the /public folder. CSV or XLSX both
// work — update it "every so often" and redeploy to refresh the dashboard.
// Patient data must NEVER sit in /public (anyone on the internet can download it). Empty = no shared
// file: staff load the spreadsheet with "Cargar archivo" and it stays in their own browser.
export const DATA_URL = '';

// Optional passcode gate. Leave '' for an open portal, or set a shared code as a
// light barrier. NOTE: this is NOT real security — for sensitive health data,
// proper per-user logins need Supabase (we can add that later).
export const PASSCODE = '';

// The campaign's targets — these drive the thermometer, gauges and simulator.
export const CAMPANA = {
  organizacion: 'Cliente',
  nombre: 'Tamizaje VPH 2026',
  meta_pacientes: 1410,
  meta_contactabilidad: 0.65,
  meta_conversion: 0.45,
  agentes_base: 4,
  dias_habiles: 5,
};
